import BaseOnboarding from 'onboarding/onboardings/baseonboarding';
import AllAccountsTree from 'onboarding/onboardings/AllAccountsOnboarding/steps/AllAccountsTree';
import store from 'store';
import AppEventBus from 'utils/appEventBus';
import onboardingManager from 'onboarding/onboardingmanager';
import AccountsListOnboarding from 'onboarding/onboardings/AccountsListOnboarding/accountsListOnboarding';
import nextFrame from 'utils/nextFrame';
import {forceExpandSidebar} from 'onboarding/utils/sidebar';


class AllAccountsOnboarding extends BaseOnboarding {
  static get name () {
    return 'all-accounts-list-onboarding';
  }

  static get trackingName () {
    return 'onboarding_accounts_series_1';
  }

  steps () {
    return [
      {
        target: '#sidebar-accounts-section',
        attachToHighlight: true,
        header: 'Аккаунты',
        component: AllAccountsTree,
        params: {
          placement: 'right',
          enableScrolling: true,
          enableScrollingAnimation: true
        },
        width: '408px',
        highlightTarget: '#sidebar-accounts-section',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 4,
          maskSizeOffsetY: 8,
          overflowBoundariesEl: '#page-layout-sidebar .middle-content'
        },
        events: {
          on () {
            forceExpandSidebar.on();

            // collapse all sidebar expandable staff
            store.dispatch('sidebar/COLLAPSE_ALL_ITEMS');

            // expand all accounts
            if (!store.getters['sidebar/isAllAccountsExpanded']) {
              store.dispatch('sidebar/TOGGLE_EXPAND_ALL_ACCOUNTS');
            }

            window.ymReachGoal('ONBOARDING_ACCOUNTS_START');
          },
          off () {
            forceExpandSidebar.off();
          }
        }
      },
      {
        target: '#sidebar-accounts-section',
        attachToHighlight: true,
        header: 'Кликните на любой аккаунт в боковом меню, чтобы перейти дальше',
        params: {
          placement: 'right',
          enableScrolling: true
        },
        width: '408px',
        highlightTarget: '#sidebar-accounts-section',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 4,
          maskSizeOffsetY: 8,
          allowClickInside: true,
          overflowBoundariesEl: '#page-layout-sidebar .middle-content'
        },
        hideFinishButton: true,
        events: {
          on: (mTourCtx) => {
            // disable opening of usual-accounts in onboarding step
            store.dispatch('sidebar/TOGGLE_ENABLED_ACCOUNTS_EXPANDING', false);
            store.dispatch('routing/RESET_INSTRUMENT_ROUTES');

            document.getElementById('page-layout').addEventListener('click', () => {
              // trigger finish callback to mark onboarding as finished
              mTourCtx.callbacks.onStop();
            }, {once: true});

            // run next onboarding step after route changed
            AppEventBus.$once('ROUTE_NAVIGATION_COMPLETE', () => {
              nextFrame(() => {
                onboardingManager.scheduleOnboarding(AccountsListOnboarding, this.trackingParams);
              });
            });
          },
          off () {
            // enable opening of usual-accounts after onboarding
            store.dispatch('sidebar/TOGGLE_ENABLED_ACCOUNTS_EXPANDING', true);
          }
        }
      }
    ];
  }
}

export default AllAccountsOnboarding;
